export default {
  'Text': 'النص',
  'Styles': 'النمط',
  'Text here': 'اضف النص هنا',
  'Add subtitles': 'إضافة عناوين فرعية',
  'Text Color': 'لون النص',
  'Outline': 'الإطار الخارجي',
  'Background': 'خلفية',
  'Position': 'الوضع',
}